import { getDataFromSSR } from "@/handlers/client/commonClient";
import { parseMatchDetails } from "@/utils/ipl";
import { logger } from "@/utils/logging/log-util";
import { useEffect, useState } from "react";
import SVG from "react-inlinesvg";

const MatchBanner = () => {
  const [match, setMatch] = useState(null);

  const [loading, setLoading] = useState(true);
  const menuItems = [
    { name: "Overview", path: "/sports/cricket/india-tour-of-england-2025" },
    { name: "Stats", path: "/sports/cricket/india-tour-of-england-2025/stats" },
    { name: "Matches", path: "/sports/cricket/india-tour-of-england-2025/schedule" },
  ];

  useEffect(() => {
    if (!loading) setLoading(true);
    async function getMatches() {
      try {
        const timeStamp = Date.now();
        const matches = await getDataFromSSR(
          `/api/getLiveMatches?seriesId=8159&time=${timeStamp}`
        );

        if (matches && matches.data?.data?.length > 0) {
          const match = await getDataFromSSR(
            `/api/getLiveMatchDetails?matchId=${matches.data?.data[0]?.match_Id}&time=${timeStamp}`
          );

          if (match && match.data?.data) {
            const matchStats = parseMatchDetails(match.data?.data);
            setMatch(matchStats);
            window.allowLivePolling = true;
          }
        } 
        else{
            setMatch(null);
        }
        // else {
        //   const recentMatches = await getDataFromSSR(
        //     `/api/getRecentMatches?time=${timeStamp}`
        //   );
        //   if (recentMatches && recentMatches.data?.data?.length > 0) {
        //     const matchStats = parseMatchData(recentMatches.data?.data[0]);
        //     setMatch(matchStats);
        //     window.allowLivePolling = false;
        //   }
        // }
        setLoading(false);
      } catch (err) {
        logger.error(err);
        setLoading(false);
      }
    }
    getMatches();
    const interval = setInterval(() => {
      if (window.allowLivePolling) getMatches();
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  if (loading && match) {
    // Render loading spinner
    return (
      <div className="w-full h-[6rem] flex items-center justify-center my-8">
        <div className="animate-spin rounded-full border-t-4 border-primary border-solid h-12 w-12"></div>
      </div>
    );
  }
  const teamA_score = match?.teamA_score_full.split(",")||[""];
  const teamB_score = match?.teamB_score_full.split(",")||[""];
  console.log("SCORE", teamA_score)
  const teamA_score_str = teamA_score.includes("Yet to Bat")?[false]:[teamA_score[0]?.trim().split(" ")[0]||null , teamA_score[1]?.trim().split(" ")[0]||null];
  const teamA_overs_str = [teamA_score[0]?.trim().split(" ")[1]||null , teamA_score[1]?.trim().split(" ")[1]||null];

  const teamB_score_str = teamB_score.includes("Yet to Bat")?[false]:[teamB_score[0]?.trim().split(" ")[0]||null , teamB_score[1]?.trim().split(" ")[0]||null];
  const teamB_overs_str = [teamB_score[0]?.trim().split(" ")[1]||null , teamB_score[1]?.trim().split(" ")[1]||null];

  return (!loading &&match) ? (
    <div>
      <a href={match?.url || "/sports/cricket/india-tour-of-england-2025"}>
      <div className="w-full shadow-lg my-8 bg-[#F1F2FA] py-3 px-1 md:px-3  h-[6rem] flex items-center gap-2 rounded-lg">
        {/* left  */}
        <div className="relative flex items-center gap-1 w-[20%] md:w-[25%]">
          {/* <Sponsor electionKeys={{showSponsor: true}} name=""/> */}
          <div className="absolute left-1"><SVG src="/assets/icons/svg/batsman.svg" className="w-24 h-24"/></div>
          <div className="hidden md:block absolute left-8 z-10 text-center">India Tour of England <span className="font-semibold">2025</span></div>
          <div className="md:hidden absolute left-1 text-sm z-10 text-center">Ind Tour of Eng</div>
        </div>
        {/* banner  */}
        <div className="relative bg-primary z-0 w-[80%] md:w-[55%] h-[7rem] py-2 px-2 md:px-8 flex flex-col justify-center gap-4">
          <div className="absolute top-0 -left-1.5 w-2 h-2 bg-[#9C1D1E] z-[-1] rounded-t-lg" />
          <div className="absolute bottom-0 -left-1.5 w-2 h-2 bg-[#9C1D1E] z-[-1] rounded-b-lg" />
          <div className="absolute top-0 -right-1.5 w-2 h-2 bg-[#9C1D1E] z-[-1] rounded-t-lg" />
          <div className="absolute bottom-0 -right-1.5 w-2 h-2 bg-[#9C1D1E] z-[-1] rounded-b-lg" />

          
            <div className="hidden md:flex w-full items-center justify-between gap-2 mt-1">
              <div className="w-[46%] flex items-center gap-1 justify-start">
                <div className="flex flex-col items-center jusitfy-center text-white font-semibold gap-2">
                <img
                  width={40}
                  height={40}
                  src={match?.altLogoA||"/assets/englandLogo.png"}
                  alt="teamA logo"
                  className=""
                />
                  <span>{match.teamA_name?.toUpperCase()||"--"}</span>
                </div>
                
                <div className="flex flex-col items-start md:mx-1 justify-center text-white">
                  <div className="font-semibold flex items-start gap-0 md:gap-2 text-[15px]">
                   {teamA_score_str[0]?<div className="flex flex-col items-start gap-0.5">
                      <span>{teamA_score_str[0]}
                      {(match?.batting_team && match?.batting_team == "A") && !teamA_score_str[1]
                      ? "*"
                      : ""}
                      </span>
                      {!teamA_overs_str[1]&&<span className="text-[12px] opacity-70">{teamA_overs_str[0]}</span>}
                      {teamA_overs_str[1]&&<span>{teamA_score_str[1]}
                      {(match?.batting_team && match?.batting_team == "A") && teamA_score_str[1]
                      ? "*"
                      : ""}
                      </span>}
                     
                      {teamA_overs_str[1]&&<span className="text-[12px] opacity-70">{teamA_overs_str[1]}</span>}
                    </div>:<span className="flex flex-col -mt-4">
                      {/* {match.teamA_name?.toUpperCase()||"--"} */}
                      <span className="opacity-70 text-sm">Yet To Bat</span>
                      </span>}
                    {match?.winning_team == "A" && (
                      <img
                        src={"/assets/trophy.gif"}
                        width={20}
                        height={20}
                        alt="trophy gif"
                        className="md:mt-1"
                      />
                    )}
                  </div>
                </div>
              </div>

              <span className="font-light opacity-50 text-white text-lg -mx-2 md:-mx-0">
                v/s
              </span>

              <div className="w-[46%] flex items-center gap-1 justify-end">
                <div className="flex flex-col md:mx-1 items-end justify-center text-white">
                  <div className="font-semibold flex items-start text-[15px]">
                    {match?.winning_team == "B" && (
                      <img
                        src={"/assets/trophy.gif"}
                        width={20}
                        height={20}
                        alt="trophy gif"
                        className="md:mt-1"
                      />
                    )}
                     {teamB_overs_str[0]?<div className="flex flex-col items-start gap-0.5">
                      <span>{teamB_score_str[0]}
                      {match?.batting_team && match?.batting_team == "B" && !teamB_score_str[1]
                      ? "*"
                      : ""}
                      </span>
                      {!teamB_overs_str[1]&&<span className="text-[12px] opacity-70">{teamB_overs_str[0]}</span>}
                      {teamB_overs_str[1]&&<span>{teamB_score_str[1]}
                      {match?.batting_team && match?.batting_team == "B" && teamB_score_str[1]
                      ? "*"
                      : ""}
                      </span>}
                     
                      {teamB_overs_str[1]&&<span className="text-[12px] opacity-70">{teamB_overs_str[1]}</span>}
                    </div>:<span className="flex flex-col -mt-4">
                      {/* {match.teamB_name?.toUpperCase()||"--"} */}
                      <span className="opacity-70 text-sm">Yet To Bat</span>
                      </span>}
                  </div>
                </div>
                <div className="flex flex-col items-center jusitfy-center text-white font-semibold gap-2">
                  <img
                    width={40}
                    height={40}
                    src={match?.altLogoB||"/assets/indiaLogo.png"}
                    alt="teamB logo"
                    className=""
                  />
                  <span>{match.teamB_name?.toUpperCase()||"--"}</span>
                </div>
              </div>
            </div>

{/* mobile view  */}
            <div className="md:hidden w-full flex flex-col items-start gap-2 text-white mt-1 -mb-2">
              <div className="w-full flex items-center gap-1 justify-between">
                <div className="flex items-center gap-1 text-[14px]">
                  <img
                    width={20}
                    height={20}
                    src={match?.altLogoA||"/assets/englandLogo.png"}
                    alt="teamA logo"
                    className=" "
                  />
                  {match?.teamA_name?.toUpperCase()||"--"}
                </div>
                <div className="font-semibold flex items-start text-[12px]">
                   {teamA_score_str[0]?<div className="flex items-start gap-1.5">
                      <span>{teamA_score_str[0]}
                      {(match?.batting_team && match?.batting_team == "A") && !teamA_score_str[1]
                      ? "*"
                      : ""}
                      </span>
                      {!teamA_overs_str[1]&&<span className="text-[12px] opacity-70">{teamA_overs_str[0]}</span>}
                      {teamA_overs_str[1]&&<span>{" & "+teamA_score_str[1]}
                      {(match?.batting_team && match?.batting_team == "A") && teamA_score_str[1]? "*": ""}
                      </span>}
                     
                      {teamA_overs_str[1]&&<span className="text-[12px] opacity-70">{teamA_overs_str[1]}</span>}
                    </div>:<span className="flex flex-col">
                      {/* {match.teamA_name?.toUpperCase()||"--"} */}
                      <span className="opacity-70 text-sm">Yet To Bat</span>
                      </span>}
                    {match?.winning_team == "A" && (
                      <img
                        src={"/assets/trophy.gif"}
                        width={20}
                        height={20}
                        alt="trophy gif"
                        className="md:mt-1"
                      />
                    )}
                  </div>
                
              </div>

              <div className="w-full flex items-center gap-1 justify-between">
                <div className="flex items-center gap-1 text-[14px]">
                  <img
                    width={20}
                    height={20}
                    src={match?.altLogoB||"/assets/indiaLogo.png"}
                    alt="teamB logo"
                    className=""
                  />
                  {match?.teamB_name?.toUpperCase()||"--"}
                </div>
                <div className="font-semibold flex items-start text-[12px]">
                    {match?.winning_team == "B" && (
                      <img
                        src={"/assets/trophy.gif"}
                        width={20}
                        height={20}
                        alt="trophy gif"
                        className=""
                      />
                    )}
                     {teamB_overs_str[0]?<div className="flex items-start gap-1.5">
                      <span>{teamB_score_str[0]}
                      {match?.batting_team && match?.batting_team == "B" && !teamB_score_str[1]? "*": ""}
                      </span>
                      {!teamB_overs_str[1]&&<span className="text-[12px] opacity-70 text-xs">{teamB_overs_str[0]}</span>}
                      {teamB_overs_str[1]&&<span>{" & "+ teamB_score_str[1]}
                      {match?.batting_team && match?.batting_team == "B" && teamB_score_str[1]? "*": ""}
                      </span>}
                     
                      {teamB_overs_str[1]&&<span className="text-[12px] opacity-70 md:text-xs">{teamB_overs_str[1]}</span>}
                    </div>:<span className="flex flex-col">
                      {/* {match.teamB_name?.toUpperCase()||"--"} */}
                      <span className="opacity-70 text-sm">Yet To Bat</span>
                      </span>}
                  </div>
                
                
              </div>
            </div>
          

          {match?.live_status && (
            <div className="w-full border-t border-opacity-70 md:border-none text-white border-white text-xs text-center pt-2 md:pt-1 mt-1 md:-mt-4 line-clamp-1">
              {match?.live_status || ""}
            </div>
          )}
        </div>

        {/* right  */}
        <div className="flex flex-col items-center w-[20%] md:w-[25%] gap-1">
          <div className="flex flex-col md:flex-row items-center">
            <span className="font-semibold text-xs md:text-lg flex items-center">
              <img
                height={24}
                width={24}
                src="/assets/liveGif.gif"
                alt="live icon"
              />
                LIVE
            </span>
            <span className="hidden md:block bg-[#0000004D] rounded-full w-1 h-1 mx-2"></span>
            <span className="text-[#0000004D] text-xs md:text-sm">
              {match?.match_no}
            </span>
          </div>
          <a
            href="/sports/cricket/india-tour-of-england-2025"
            className="text-primary font-semibold text-[12px] md:text-sm text-center md:text-left"
          >
            <span>Match Centre</span>
            <span className="mx-1">{">"}</span>
          </a>
        </div>
      </div>
      <div className="md:hidden w-full flex items-center justify-between -mt-2 gap-2">
        {menuItems?.map((item, index) => {
          return (
            <a href={item?.path} key={index} className="w-[33%]">
              <div className="bg-primary bg-opacity-20 py-1 text-sm px-2 md:px-4 rounded-full border border-primary text-primary flex items-center justify-center gap-1">
                <span>{item.name}</span>
                <SVG src="/assets/icons/svg/send1.svg" />
              </div>
            </a>
          );
        })}
      </div>
      </a>
    </div>
  ) : (
    <>
    </>
  );
};

export default MatchBanner;
